import N8nHoverCard from './HoverCard.vue';

export default N8nHoverCard;
